export const selectCartPrice = (state) => state.productsReducer.cartPrice;
